@if (isMobile) {
  @if (isLoading) {
    <osc-splash-screen class="splash-screen"></osc-splash-screen>
  } @else {
    <main>
      <div class="ipm__main">
        <osc-utils-spinner #appSpinner [spinnerId]="spinnerService.mainSpinnerId"></osc-utils-spinner>
        <router-outlet></router-outlet>
      </div>
    </main>
  }
} @else {
  <evc-platform
    [inputAppIdentification]="appIdentification"
    inputForcedTheme="light"
    [inputSettingsMenu]="settingsMenu"
    (logout)="logout()"
    [changeOrganization]="changeOrganization"
    class="app__platform"
  >
    <main class="web">
      @if (!isLoading) {
        <div class="ipm__main">
          <osc-utils-spinner #appSpinner [spinnerId]="spinnerService.mainSpinnerId"></osc-utils-spinner>
          <router-outlet></router-outlet>
        </div>
      }
    </main>
  </evc-platform>
}
